import { createContext } from 'react';
import { CompGroupListCreate } from 'api';
import { CellAdditions, CellsChanged } from 'components/ScalarDatasheet/ScalarDatasheet.props';

type OnCellsChanged = (cellsChanged: Partial<CellsChanged>[], cellsAdded?: CellAdditions) => void;
export interface CompGroupsContextType {
  group: CompGroupListCreate | null;
  onCellsChanged: OnCellsChanged | null;
}

const CompGroupsContext = createContext<CompGroupsContextType>({} as CompGroupsContextType);

export default CompGroupsContext;
